import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.751 3.001a.75.75 0 1 0-1.5 0v4.25h-4.25a.75.75 0 1 0 0 1.5h4.25v4.25a.75.75 0 0 0 1.5 0v-4.25h4.25a.75.75 0 0 0 0-1.5h-4.25v-4.25Z" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
